module.exports = __webpack_public_path__ + "img/locator-sentosa-orange.7ab96049.svg";